import { RequestState } from "common/RequestState";
import reduceReducers from "reduce-reducers";

/**
 * requestState & correlationId are reserved names that are merged into the payload from the api
 * requestStateHelper can be used to check the state of requests during component rendering
 * correlationId can be used in SUMOLogic to track down the nature of errors
 */
export const createGenericListItemReducer = (
  requestedActionType,
  receivedActionType,
  failedActionType,
  resetActionType,
  customReducer,
  customInitialState
) => {
  const initialState = {};
  const genericListItemReducer = (state = customInitialState || initialState, action) => {
    //Action id must be supplied
    if (!action.id) {
      return state;
    }
    switch (action.type) {
      case requestedActionType:
        return {
          ...state,
          [action.id]: { ...state[action.id], ...action.payload, requestState: RequestState.InProgress }
        };
      case receivedActionType:
        return {
          ...state,
          [action.id]: { ...state[action.id], ...action.payload, requestState: RequestState.Finished }
        };
      case failedActionType:
        return {
          ...state,
          [action.id]: {
            ...state[action.id],
            ...action.payload,
            requestState: RequestState.Failed,
            correlationId: action.correlationId
          }
        };
      case resetActionType:
        return {
          ...state,
          [action.id]: { requestState: RequestState.NotRequested }
        };
      default:
        return state;
    }
  };

  return customReducer ? reduceReducers(genericListItemReducer, customReducer) : genericListItemReducer;
};
